import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const Stages = ({ stages, setStage, currentStage, currentStep, recommendation }) => {
  const { t } = useTranslation();

  return <ul className={styles.stages}>
    {stages.map((stage, index) => 'results' !== stage.key && ('both' === recommendation || stage.key === recommendation) ? <li
      key={index}
      className={styles.stages + ' ' + (
        currentStage.key === stage.key ? styles.selected : ''
      ) + ' ' + (
        stage.completed ? styles.complete : ''
      )}
    >
      {t(`tool_ui.${stage.key}.title`)}

      <div className={styles.steps_left}>
        {stage.steps.length - stage.curStep > 0 ? stage.steps.length - stage.curStep : 0} {stage.steps.length - stage.curStep !== 1 ? t('tool_ui.global.step_left_plural') : t('tool_ui.global.step_left_singular')}
      </div>

      <div className={styles.progress}>
        <span style={{width: (stage.curStep / stage.steps.length * 100 < 100 ? stage.curStep / stage.steps.length * 100 : 100) + '%'}}></span>
      </div>

      <ul>
        {stage.steps.map((step, index) => <li
          key={index}
          className={(
            currentStage.key === stage.key && currentStep.key === step.key ? styles.step_selected : step.completed ? styles.step_complete : ''
          )}
        >
          <span></span>
          {t(step.name)}
        </li>)}
      </ul>
    </li> : '')}
  </ul>;
}

export default Stages;
